module.exports = __webpack_public_path__ + "img/chat-text.1bb2c53e.svg";